import { render } from "./MoveRight.vue?vue&type=template&id=77f6562d"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MoveRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77f6562d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77f6562d', __exports__)) {
    api.reload('77f6562d', __exports__)
  }
  
  module.hot.accept("./MoveRight.vue?vue&type=template&id=77f6562d", () => {
    api.rerender('77f6562d', render)
  })

}


export default __exports__